import React, { Component } from 'react'
import { DragLayer } from 'react-dnd'
import URL from 'url-parse';

@DragLayer(monitor => ({
	item: monitor.getItem(),
	initialOffset: monitor.getInitialSourceClientOffset(),
	currentOffset: monitor.getSourceClientOffset(),
	isDragging: monitor.isDragging()
}))
class MyLinkDragLayer extends Component {

	makeStyle() {
		const { initialOffset, currentOffset } = this.props
		if (!initialOffset || !currentOffset) {
			return null
		}

		return {
			display: 'block',
			position: 'fixed',
			pointerEvents: 'none',
			zIndex: 10000,
			top: currentOffset.y + "px",
			left: initialOffset.x + "px"
		}
	}

    removeErrorFavicon(e) {
        e.target.parentNode.remove(e.target);
    }

	render() {
		const { isDragging } = this.props
		if (!isDragging) {
			return null
		}

		const { item } = this.props.item
    const linkUrl = new URL(item.url);
    const faviconUrl = linkUrl.origin + '/favicon.ico';

		return (
			<div className="item_drag type_thumb" style={this.makeStyle()}>
				<div className="item_order">
					<div className="basic_item">
						<div className="wrap_drag">
							<span className="ico_blog ico_drag" />
						</div>
						<span className="txt_name">
							{item.linkName}
							<span className="txt_url">{item.url}</span>
						</span>
					</div>
				</div>
			</div>
		)
	}
}

export default MyLinkDragLayer
